import { css } from 'styled-components';
import { getColorAlias } from '../../utils/index.js';

const getTabsColor = (props) => {
    if (props.disabled) {
        return css `
      pointer-events: none;
      color: ${getColorAlias('contentDisabled')};
    `;
    }
    if (props.selected) {
        return css `
      color: ${getColorAlias('contentDefault')};
    `;
    }
    return css `
    color: ${getColorAlias('contentSubdued')};
  `;
};

export { getTabsColor };
